import type { Article } from './types';

export const articles: Article[] = [
  {
    id: 'article-1',
    slug: 'world-cup-2026-preview',
    title: '2026世界杯前瞻：各队备战动态与夺冠热门分析',
    excerpt: '距离2026年世界杯开幕越来越近，各支参赛球队正紧锣密鼓地进行备战。本文深入分析本届世界杯的夺冠热门球队、黑马潜力以及赛制变化。',
    content: `<p>距离2026年世界杯开幕越来越近，全球球迷的期待值也在不断攀升。本届世界杯将由美国、加拿大和墨西哥三国联合举办，这也是世界杯历史上首次由三个国家共同承办。</p>
    <h2>赛制变革与新规则</h2>
    <p>2026年世界杯将扩军至48支球队，这是继1998年扩军到32支之后又一次重大变革。小组赛将采用16个小组、每组3支球队的赛制，每组前两名晋级32强淘汰赛。</p>
    <p>新赛制意味着比赛场次将从64场增加到80场，赛程也将相应延长。这对于球员体能和球队阵容深度都提出了更高的要求。</p>
    <h2>夺冠热门分析</h2>
    <p>卫冕冠军阿根廷队在梅西退役后经历重建期，但年轻一代球员的崛起令人期待。法国队拥有姆巴佩等世界级球星，阵容厚度冠绝群雄。巴西队近年来青训成果丰硕，新生代球员表现出色。英格兰队在多届大赛积累经验后，也具备了冲击冠军的实力。</p>
    <h2>黑马潜力球队</h2>
    <p>日本队近年来进步神速，多名球员效力于欧洲五大联赛。摩洛哥队在2022年世界杯闯入四强后信心大增。美国队作为东道主之一，拥有主场优势和一批在欧洲踢球的年轻才俊。</p>
    <h2>值得关注的球星</h2>
    <p>法国前锋姆巴佩无疑是本届世界杯的最大看点，他将力争带领法国队再次登顶。挪威中锋哈兰德如果能够率队晋级，将成为金靴奖的有力争夺者。英格兰中场贝林厄姆的成长速度惊人，有望在本届赛事中成为世界级巨星。</p>
    <h2>赛事经济影响</h2>
    <p>据估算，2026年世界杯将为三个东道主国家带来超过50亿美元的经济收益。各大城市的基础设施建设、旅游业发展和就业机会都将得到显著提升。对于全球体育产业而言，这也是一次巨大的商业机遇。</p>
    <p>随着开幕日期的临近，各支球队的热身赛和阵容调整将更加频繁。开元体育将持续为您带来最新、最全面的世界杯报道，敬请关注。</p>`,
    categoryId: 'cat-1',
    categoryName: '足球',
    coverImage: 'https://readdy.ai/api/search-image?query=Professional%20soccer%20stadium%20atmosphere%20with%20dramatic%20lighting%2C%20green%20grass%20field%2C%20players%20in%20action%2C%20stadium%20crowd%20silhouettes%2C%20warm%20golden%20sunset%20light%2C%20sports%20photography%20style%2C%20dynamic%20composition%2C%20cinematic%20mood&width=1200&height=630&seq=article-football-01&orientation=landscape',
    publishedAt: '2024-12-15',
    views: 12580,
    tags: ['世界杯', '足球', '2026', '赛事前瞻'],
  },
  {
    id: 'article-2',
    slug: 'nba-season-preview-2025',
    title: 'NBA新赛季展望：群雄逐鹿，谁将问鼎总冠军',
    excerpt: 'NBA新赛季即将拉开帷幕，各支球队经过休赛期的调整和补强后蓄势待发。本文全面分析新赛季的格局变化、关键交易以及各支球队的实力评估。',
    content: `<p>NBA新赛季即将拉开帷幕，经过一个充满戏剧性的休赛期，联盟格局发生了显著变化。多支球队通过交易和选秀完成了阵容升级，新赛季的竞争将更加激烈。</p>
    <h2>休赛期重大交易回顾</h2>
    <p>今年休赛期堪称近年来最活跃的交易市场之一。多支争冠球队通过交易获得了关键拼图，而一些重建球队则通过选秀积累了未来资产。</p>
    <h2>东部格局分析</h2>
    <p>波士顿凯尔特人作为卫冕冠军，保留了核心阵容，依然是东部最强球队。密尔沃基雄鹿在字母哥的带领下持续保持竞争力。费城76人和纽约尼克斯在休赛期都有针对性补强。</p>
    <h2>西部格局分析</h2>
    <p>西部竞争一如既往地激烈。丹佛掘金在约基奇的带领下展现出冠军底蕴。俄克拉荷马雷霆年轻阵容的成长速度令人惊叹。达拉斯独行侠在东契奇带领下不断提升。</p>
    <h2>值得关注的新秀</h2>
    <p>今年的新秀阵容堪称近年来最强之一。状元秀展现出了即战力与天赋的完美结合，探花秀的技术全面性令人印象深刻。多名乐透秀都有望在新秀赛季就进入轮换阵容。</p>
    <h2>MVP热门人选</h2>
    <p>约基奇、字母哥、东契奇和亚历山大都是MVP的有力竞争者。年轻一代球员的崛起让MVP争夺变得更加扑朔迷离。</p>`,
    categoryId: 'cat-2',
    categoryName: '篮球',
    coverImage: 'https://readdy.ai/api/search-image?query=NBA%20basketball%20court%20intense%20game%20action%2C%20player%20dunking%2C%20arena%20lights%20dramatic%20atmosphere%2C%20professional%20sports%20photography%2C%20crowd%20energy%2C%20warm%20tone%20lighting%2C%20dynamic%20motion%20blur&width=1200&height=630&seq=article-basketball-01&orientation=landscape',
    publishedAt: '2024-12-10',
    views: 9870,
    tags: ['NBA', '篮球', '新赛季', '赛事前瞻'],
  },
  {
    id: 'article-3',
    slug: 'tennis-grand-slam-analysis',
    title: '网球大满贯赛事深度解读：从技术到心理的全面剖析',
    excerpt: '大满贯赛事是网球运动的最高殿堂，本文从技术特点、心理素质、场地适应等多个维度，深入分析顶级球员在大满贯赛场上的表现与策略。',
    content: `<p>网球大满贯赛事代表着这项运动的最高水平。从硬地到红土再到草地，不同场地对球员的技术特点和身体条件提出了迥异的要求。</p>
    <h2>四大满贯场地特点</h2>
    <p>澳网和美网采用硬地场地，球速适中，适合进攻型选手发挥。法网的红土场地球速最慢，对球员的体能和耐心是极大的考验。温网的草地场地球速最快，发球上网型选手有天然优势。</p>
    <h2>顶级球员技术分析</h2>
    <p>现代网球越来越强调全面性。新生代球员普遍具备强力发球、底线相持和网前截击的全面技术。但真正能够统治大满贯的球员，往往还有一项独门绝技作为制胜法宝。</p>
    <h2>心理素质的重要性</h2>
    <p>五盘三胜制的大满贯比赛对球员的心理素质提出了极高要求。领先时如何保持专注、落后时如何调整心态、关键分如何冷静处理——这些心理层面的能力往往决定了比赛的最终走向。</p>
    <h2>体能训练与伤病预防</h2>
    <p>现代网球赛季绵长，球员需要在保持竞技状态和预防伤病之间找到平衡。科学的训练计划和合理的赛程安排是延长职业生涯的关键。</p>`,
    categoryId: 'cat-3',
    categoryName: '网球',
    coverImage: 'https://readdy.ai/api/search-image?query=Tennis%20court%20professional%20match%2C%20player%20serving%20action%2C%20clay%20court%20surface%2C%20warm%20sunset%20lighting%2C%20stadium%20atmosphere%2C%20sports%20photography%2C%20elegant%20composition%2C%20dynamic%20pose&width=1200&height=630&seq=article-tennis-01&orientation=landscape',
    publishedAt: '2024-12-08',
    views: 7560,
    tags: ['网球', '大满贯', '技术分析', '心理素质'],
  },
  {
    id: 'article-4',
    slug: 'swimming-technique-guide',
    title: '游泳技术进阶指南：从入门到精通的完整训练方案',
    excerpt: '无论您是初学者还是有一定基础的游泳爱好者，这份全面的游泳技术指南都将帮助您提升泳姿、增强耐力，实现从入门到精通的跨越。',
    content: `<p>游泳是一项全身性的有氧运动，对心肺功能、肌肉力量和身体协调性都有极好的锻炼效果。本文将从基础到进阶，为您呈现完整的游泳技术训练方案。</p>
    <h2>四种泳姿技术要点</h2>
    <p>自由泳是最基础的泳姿，强调身体流线型和手臂划水效率。蛙泳注重腿部蹬夹水动作的节奏感。仰泳要求良好的身体平衡和水感。蝶泳则需要强大的核心力量和协调能力。</p>
    <h2>呼吸技巧训练</h2>
    <p>正确的呼吸是游泳技术的核心。通过专门的呼吸训练，可以帮助您在游泳过程中保持稳定的供氧，减少疲劳感，提升游泳距离和速度。</p>
    <h2>转身与出发技术</h2>
    <p>对于追求速度的游泳者来说，出发和转身技术是提升成绩的关键环节。一个流畅的滚翻转身可以节省0.5到1秒的时间，在竞技比赛中这可能就是胜负之差。</p>
    <h2>训练计划制定</h2>
    <p>根据个人目标和当前水平，制定合理的训练计划至关重要。建议初学者每周游泳3-4次，每次30-45分钟。进阶者可以增加训练频次和强度。</p>`,
    categoryId: 'cat-4',
    categoryName: '游泳',
    coverImage: 'https://readdy.ai/api/search-image?query=Swimmer%20in%20Olympic%20pool%2C%20freestyle%20stroke%2C%20crystal%20clear%20blue%20water%2C%20dynamic%20splash%2C%20professional%20swimming%20action%2C%20bright%20indoor%20lighting%2C%20sports%20photography%2C%20athletic%20body%20in%20motion&width=1200&height=630&seq=article-swimming-01&orientation=landscape',
    publishedAt: '2024-12-05',
    views: 6230,
    tags: ['游泳', '技术指导', '训练方案', '初学者'],
  },
  {
    id: 'article-5',
    slug: 'marathon-training-plan',
    title: '马拉松训练全攻略：从5公里到42公里的科学进阶之路',
    excerpt: '完成一场马拉松是许多跑者的梦想。本文为您提供从零基础到完赛全马的科学训练计划，包含配速策略、营养补给和伤病预防等关键内容。',
    content: `<p>马拉松不仅是对身体的挑战，更是对意志力的考验。科学的训练计划是安全完赛的基础。本文将引导您从5公里开始，逐步进阶到42.195公里的全程马拉松。</p>
    <h2>基础期训练（0-3个月）</h2>
    <p>对于零基础的跑者，前三个月的目标是建立跑步习惯和基础体能。建议从跑步+步行的组合开始，逐步增加跑步时间比例。每周训练3-4次，每次30-45分钟。</p>
    <h2>进阶期训练（3-6个月）</h2>
    <p>在建立基础后，开始引入不同的训练类型：轻松跑、节奏跑、间歇跑和长距离慢跑。每种训练都有不同的目的，综合运用可以有效提升跑步能力。</p>
    <h2>赛前冲刺期（最后8周）</h2>
    <p>赛前8周是训练的关键时期。需要合理安排长距离跑、减量恢复和赛前准备。最后两周开始逐渐减少训练量，确保以最佳状态站上起跑线。</p>
    <h2>营养与补给策略</h2>
    <p>马拉松比赛中的能量补给至关重要。了解如何选择和使用能量胶、电解质饮料，以及比赛当天的饮食安排，可以显著提升比赛体验和完赛成绩。</p>`,
    categoryId: 'cat-5',
    categoryName: '跑步',
    coverImage: 'https://readdy.ai/api/search-image?query=Marathon%20runners%20on%20city%20street%2C%20group%20of%20athletes%20running%2C%20morning%20sunlight%2C%20urban%20landscape%20background%2C%20sports%20event%20atmosphere%2C%20dynamic%20movement%2C%20warm%20golden%20light%2C%20professional%20photography&width=1200&height=630&seq=article-running-01&orientation=landscape',
    publishedAt: '2024-12-01',
    views: 8450,
    tags: ['马拉松', '跑步', '训练计划', '营养补给'],
  },
  {
    id: 'article-6',
    slug: 'strength-training-beginner',
    title: '力量训练入门：打造科学的健身计划',
    excerpt: '力量训练是健身的核心组成部分。本文为初学者提供一份完整的力量训练入门指南，包含动作要领、训练频率和饮食建议。',
    content: `<p>力量训练不仅能帮助您塑造理想体型，还能提升新陈代谢率、增强骨骼密度、改善身体姿态。无论您是男性还是女性，力量训练都是健身计划中不可或缺的一部分。</p>
    <h2>基础动作教学</h2>
    <p>深蹲、硬拉、卧推、推举和划船是力量训练的五大基础动作。掌握这些动作的正确姿势，远比追求大重量更重要。错误的动作不仅训练效果打折扣，还可能导致严重伤病。</p>
    <h2>训练分化方案</h2>
    <p>根据训练频率和目标，可以选择不同的训练分化方案。全身训练适合每周2-3次的初学者，上下肢分化适合每周4次的进阶者，五分化训练适合高频率训练者。</p>
    <h2>渐进超负荷原则</h2>
    <p>力量增长的核心原理是渐进超负荷——不断给肌肉施加略高于其当前能力范围的刺激。可以通过增加重量、增加组数、增加次数或缩短休息时间来实践这一原则。</p>
    <h2>营养与恢复</h2>
    <p>训练后的营养补充和充足的睡眠是肌肉生长的关键。蛋白质摄入、碳水化合物补充和水分平衡都应纳入训练计划中。</p>`,
    categoryId: 'cat-6',
    categoryName: '健身',
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20gym%20interior%20with%20weights%20and%20equipment%2C%20person%20doing%20strength%20training%2C%20clean%20minimalist%20space%2C%20natural%20light%20from%20large%20windows%2C%20warm%20tone%2C%20professional%20fitness%20photography%2C%20motivational%20atmosphere&width=1200&height=630&seq=article-fitness-01&orientation=landscape',
    publishedAt: '2024-11-28',
    views: 10320,
    tags: ['健身', '力量训练', '入门指南', '营养'],
  },
  {
    id: 'article-7',
    slug: 'yoga-mindfulness-guide',
    title: '瑜伽与正念：寻找身心平衡的修习之道',
    excerpt: '瑜伽不仅是身体的锻炼，更是心灵的修行。本文探讨瑜伽与正念冥想的结合，帮助您在快节奏的现代生活中找到内心的宁静与身体的力量。',
    content: `<p>在当今快节奏的社会中，越来越多的人开始寻求身心健康的平衡点。瑜伽与正念冥想的结合，为现代人提供了一条通向内在平静的道路。</p>
    <h2>瑜伽的起源与哲学</h2>
    <p>瑜伽源自印度，有着数千年的历史。瑜伽（Yoga）一词本身意为"连接"或"合一"，指的是身体、心灵与精神的统一。了解瑜伽的哲学背景，有助于更深层次地理解和体验瑜伽修习。</p>
    <h2>基础体式教学</h2>
    <p>山式、下犬式、战士系列、树式等基础体式是瑜伽修习的基石。每个体式都有其独特的功效，有的增强力量，有的提升柔韧性，有的促进放松。</p>
    <h2>正念冥想的实践</h2>
    <p>正念冥想是瑜伽修习的重要组成部分。通过将注意力集中在呼吸、身体感受或当下体验，可以训练心智的专注力和觉察力。每日10-20分钟的冥想练习，就能带来显著的身心变化。</p>
    <h2>建立日常修习习惯</h2>
    <p>持续性是瑜伽修习的关键。建议从每周3次、每次30分钟开始，逐步建立稳定的修习习惯。早晨或傍晚都是适合修习的时间段。</p>`,
    categoryId: 'cat-7',
    categoryName: '瑜伽',
    coverImage: 'https://readdy.ai/api/search-image?query=Yoga%20practice%20in%20serene%20studio%2C%20woman%20in%20meditation%20pose%2C%20soft%20natural%20morning%20light%2C%20warm%20wooden%20floor%2C%20plants%20decoration%2C%20peaceful%20atmosphere%2C%20minimalist%20interior%2C%20wellness%20lifestyle%20photography&width=1200&height=630&seq=article-yoga-01&orientation=landscape',
    publishedAt: '2024-11-25',
    views: 5890,
    tags: ['瑜伽', '正念', '冥想', '身心健康'],
  },
  {
    id: 'article-8',
    slug: 'badminton-skills-improvement',
    title: '羽毛球技术提升秘籍：从业余到高手的进阶之路',
    excerpt: '羽毛球是深受大众喜爱的运动项目。本文从握拍、步法、击球技术和战术意识四个方面，为羽毛球爱好者提供系统的技术提升方案。',
    content: `<p>羽毛球运动在中国有着广泛的群众基础。从公园晨练到专业球馆，随处可见羽毛球爱好者的身影。但要从业余水平进阶到高手行列，需要有系统的训练方法。</p>
    <h2>正确握拍是基础</h2>
    <p>正手握拍和反手握拍是羽毛球的两种基本握拍方式。正确的握拍姿势决定了击球的力量和控制力。许多业余球友的技术瓶颈，根源就在于握拍方式不正确。</p>
    <h2>步法训练是核心</h2>
    <p>羽毛球场上的移动速度决定了您能否及时到位击球。并步、交叉步、蹬转步和后退步是四种基本步法。通过系统的步法训练，可以显著提升场上移动效率。</p>
    <h2>击球技术精讲</h2>
    <p>高远球、杀球、吊球、网前球、平抽球是羽毛球的五种核心击球技术。每种技术都有其特定的使用场景和发力技巧。掌握这些技术的精髓，需要对每一项进行反复练习。</p>
    <h2>战术意识培养</h2>
    <p>技术和战术相辅相成。了解对手的弱点、合理运用场地空间、把握进攻和防守的转换时机，这些都是高水平羽毛球运动员必备的战术素养。</p>`,
    categoryId: 'cat-8',
    categoryName: '羽毛球',
    coverImage: 'https://readdy.ai/api/search-image?query=Badminton%20court%20professional%20match%2C%20player%20smashing%20shuttlecock%2C%20indoor%20sports%20hall%2C%20bright%20lighting%2C%20dynamic%20action%20pose%2C%20sports%20photography%2C%20athletic%20movement%2C%20focused%20expression&width=1200&height=630&seq=article-badminton-01&orientation=landscape',
    publishedAt: '2024-11-20',
    views: 4320,
    tags: ['羽毛球', '技术提升', '训练方法', '战术'],
  },
  {
    id: 'article-9',
    slug: 'football-tactics-evolution',
    title: '现代足球战术演进：从经典442到灵活多变的战术体系',
    excerpt: '足球战术在过去几十年中经历了翻天覆地的变化。本文回顾足球战术的演进历程，分析当代主流战术体系的特点与发展趋势。',
    content: `<p>足球战术的演进是一部不断革新和突破的历史。从20世纪60年代的经典4-4-2阵型，到瓜迪奥拉时代的传控足球，再到克洛普的高压逼抢体系，足球战术从未停止进化。</p>
    <h2>经典时代的战术基石</h2>
    <p>4-4-2阵型是足球战术史上的经典之作。双前锋配置、平行中场站位和四人防线构成了一个攻守平衡的体系。这种阵型在1990年代和21世纪初达到了巅峰。</p>
    <h2>传控足球的兴起</h2>
    <p>巴塞罗那和西班牙国家队的成功，让传控足球（Tiki-Taka）成为全球足球的风向标。高控球率、短传配合和位置轮转是传控足球的核心特征。</p>
    <h2>高压逼抢的革新</h2>
    <p>克洛普和纳格尔斯曼等教练推动了高压逼抢（Gegenpressing）战术的发展。在失去球权的瞬间立即展开反抢，成为现代顶级球队的标准配置。</p>
    <h2>数据分析与战术决策</h2>
    <p>随着科技的发展，数据分析在足球战术中的应用越来越广泛。预期进球（xG）、传球网络和跑动热力图等数据指标，为教练组的战术决策提供了科学依据。</p>`,
    categoryId: 'cat-1',
    categoryName: '足球',
    coverImage: 'https://readdy.ai/api/search-image?query=Football%20tactical%20board%20with%20formation%20markers%2C%20soccer%20coach%20explaining%20strategy%2C%20professional%20stadium%20background%2C%20warm%20ambient%20lighting%2C%20sports%20analysis%20concept%2C%20green%20tactical%20board%2C%20educational%20atmosphere&width=1200&height=630&seq=article-football-02&orientation=landscape',
    publishedAt: '2024-11-18',
    views: 6780,
    tags: ['足球', '战术分析', '现代足球', '数据'],
  },
  {
    id: 'article-10',
    slug: 'basketball-shooting-form',
    title: '篮球投篮技术全解析：提升命中率的科学方法',
    excerpt: '投篮是篮球运动中最核心的技能。本文从生物力学的角度分析完美投篮姿势，提供分级训练方法和常见错误纠正方案。',
    content: `<p>投篮是篮球运动得分的核心手段。无论是业余爱好者还是职业球员，持续优化投篮姿势和提升命中率都是永恒的训练主题。</p>
    <h2>投篮生物力学分析</h2>
    <p>一个完美的投篮动作涉及身体的多个关节协同工作。从脚部发力、膝盖弯曲、髋部伸展、肩部带动、肘部延伸到手腕拨球，每一个环节都影响着球的飞行轨迹。</p>
    <h2>投篮姿势标准化</h2>
    <p>B.E.E.F.原则是投篮姿势的经典总结：平衡（Balance）、视线（Eyes）、肘部（Elbow）和跟随动作（Follow-through）。遵循这四项原则，可以有效提升投篮的稳定性和准确性。</p>
    <h2>分级训练方法</h2>
    <p>从近框投篮到中距离再到三分线外，分级训练是提升投篮能力的高效方法。建议从自己感到舒适的射程开始，在保证命中率的前提下逐步扩展射程。</p>
    <h2>常见错误与纠正</h2>
    <p>辅助手干扰、发力不均匀、视线偏离、跟随动作不完整是业余球友最常见的投篮错误。通过视频分析和针对性训练，这些错误都可以得到有效纠正。</p>`,
    categoryId: 'cat-2',
    categoryName: '篮球',
    coverImage: 'https://readdy.ai/api/search-image?query=Basketball%20player%20shooting%20jump%20shot%2C%20perfect%20form%2C%20indoor%20court%2C%20ball%20leaving%20fingertips%2C%20dramatic%20lighting%2C%20sports%20action%20photography%2C%20athletic%20silhouette%2C%20focused%20intensity&width=1200&height=630&seq=article-basketball-02&orientation=landscape',
    publishedAt: '2024-11-15',
    views: 9120,
    tags: ['篮球', '投篮技术', '训练方法', '技巧提升'],
  },
  {
    id: 'article-11',
    slug: 'running-injury-prevention',
    title: '跑步伤病预防指南：常见跑步损伤与康复方案',
    excerpt: '跑步虽好，但不当的训练方式很容易导致伤病。本文系统介绍跑步常见伤病的预防方法和康复方案，帮助跑者安全、持久地享受跑步乐趣。',
    content: `<p>跑步膝、胫骨应力综合症、足底筋膜炎、髂胫束综合症——这些是跑者群体中最常见的伤病。大多数跑步伤病都是可以通过科学的预防措施来避免的。</p>
    <h2>跑步膝的预防与康复</h2>
    <p>跑步膝（髌股疼痛综合症）是最常见的跑步伤病，主要表现为膝盖前侧疼痛。强化股四头肌尤其是内侧头、改善跑姿、选择合适的跑鞋是预防的关键。</p>
    <h2>胫骨应力综合症</h2>
    <p>胫骨内侧疼痛通常与训练量突然增加有关。合理控制训练强度、选择较软的跑步路面、穿着缓冲性能好的跑鞋可以有效预防这一问题。</p>
    <h2>足底筋膜炎</h2>
    <p>足底筋膜炎表现为足跟底部疼痛，早晨起床第一步最为明显。足底筋膜的拉伸、足弓支撑和适当减少跑步量是主要的治疗措施。</p>
    <h2>跑姿优化建议</h2>
    <p>良好的跑姿是预防伤病的基础。保持身体挺直、步频适中（建议每分钟170-180步）、前脚掌或中足着地、避免过度跨步，这些都是值得关注的跑姿要点。</p>`,
    categoryId: 'cat-5',
    categoryName: '跑步',
    coverImage: 'https://readdy.ai/api/search-image?query=Runner%20stretching%20on%20track%20field%2C%20sports%20injury%20prevention%20concept%2C%20athletic%20person%20doing%20warmup%2C%20morning%20sunlight%2C%20stadium%20track%2C%20fitness%20lifestyle%2C%20professional%20sports%20photography%2C%20healthy%20active%20lifestyle&width=1200&height=630&seq=article-running-02&orientation=landscape',
    publishedAt: '2024-11-12',
    views: 7310,
    tags: ['跑步', '伤病预防', '康复方案', '健康'],
  },
  {
    id: 'article-12',
    slug: 'home-workout-no-equipment',
    title: '居家健身方案：无需器械的高效全身训练',
    excerpt: '没有时间去健身房？没有关系！本文为您提供一套完整的居家健身方案，无需任何器械，利用自身体重即可完成高效全身训练。',
    content: `<p>现代生活节奏快，很多人难以抽出固定时间去健身房。但好消息是，高效的健身并不一定需要器械和健身房。利用自身体重进行训练，同样可以达到理想的健身效果。</p>
    <h2>热身与激活</h2>
    <p>每次训练前5-10分钟的热身必不可少。开合跳、高抬腿、肩关节环绕和髋关节活动是简单有效的热身动作。充分热身可以提升训练效果并降低受伤风险。</p>
    <h2>上肢训练</h2>
    <p>俯卧撑是上肢训练的黄金动作。标准俯卧撑、宽距俯卧撑、钻石俯卧撑和下沉俯卧撑可以从不同角度刺激胸部和三头肌。对于进阶者，可以尝试爆发力俯卧撑。</p>
    <h2>下肢训练</h2>
    <p>深蹲、弓步蹲、保加利亚分腿蹲和臀桥是高效的腿部训练动作。单腿训练动作可以帮助纠正左右力量不平衡的问题。跳跃深蹲可以提升爆发力。</p>
    <h2>核心训练</h2>
    <p>平板支撑、侧平板、仰卧卷腹、自行车卷腹和登山跑是核心训练的经典动作。强大的核心力量不仅能让腹肌线条更明显，还能改善运动表现和日常姿态。</p>`,
    categoryId: 'cat-6',
    categoryName: '健身',
    coverImage: 'https://readdy.ai/api/search-image?query=Home%20workout%20in%20bright%20living%20room%2C%20person%20doing%20pushup%20exercise%2C%20natural%20light%20from%20windows%2C%20minimalist%20interior%2C%20yoga%20mat%20on%20wooden%20floor%2C%20fitness%20lifestyle%2C%20warm%20and%20inviting%20atmosphere%2C%20healthy%20living%20concept&width=1200&height=630&seq=article-fitness-02&orientation=landscape',
    publishedAt: '2024-11-08',
    views: 11560,
    tags: ['健身', '居家训练', '无器械', '全身训练'],
  },
];